import React from 'react'
import { Link } from 'react-router-dom'

export default function Home() {
  return (
    <div className='h-screen w-full blue-bg text-white overflow-hidden py-12 px-6 relative'>
      <Link to="/the-vision" className="text-sm py-2 px-3 bg-white text-blue-900 hover:bg-blue-200 -right-[1.8rem] rotate-90 font-semibold fixed top-36">
        The Vision
      </Link>
      <div className="h-24 mx-auto relative xl:w-1/3">
        <img src="https://res.cloudinary.com/eskwaya-lawtech/image/upload/v1699946153/logo_o0paohur_udbvyy.png" className="h-10 mx-auto" alt="logo" />
        {/* <span className="font-semibold text-3xl absolute -top-2 xl:right-[100px] right-16">&reg;</span> */}
      </div>
      <div className="h-full flex flex-col justify-center items-center -mt-12 lg:w-2/3 w-full mx-auto">
        <h2 className="text-4xl font-bold text-center font-fira">Resolve your issue easily and risk free</h2>
        <p className="mt-3 mb-6 text-lg font-semibold text-center font-taviraj">
          U-Resolve® offers the first independent online alternative dispute resolution service, for civil matters, fully digital and assisted by Artificial Intelligence.
        </p>
        <div className="flex justify-center items-center gap-8 mt-6">
          <Link to="/auth/sign-up" className="text-sm font-semibold py-3 hover:shadow-sm px-6 bg-green-800 text-white rounded hover:bg-green-900">Get Started</Link>
          <Link to="/overview" className="text-sm font-semibold py-3 hover:shadow-sm px-6 bg-white text-blue-900 rounded hover:bg-gray-100">Learn More</Link>
        </div>
      </div>
    </div>
  )
}
